import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import List from '../components/List'
import LayoutListView from '../components/LayoutListView'
import { getSafe } from '../shared/utilities'

const MINetworks = ({ location }) => {
  const configID = '7lKmI8JXJyThGGoTDnMOAY'
  const queryData = useStaticQuery(graphql`
    {
      allContentfulSubMenu(
        filter: { menu: { eq: "Networks" } }
        sort: { fields: title, order: ASC }
      ) {
        edges {
          node {
            id
            title
            url
            description {
              description
            }
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
  `)

  const TYPE = 'MI Networks'
  const IMAGE_HEIGHT = 150
  const data = queryData.allContentfulSubMenu.edges.map(obj => ({
    id: obj.node.id,
    title: obj.node.title,
    body: getSafe(() => obj.node.description.description),
    image: obj.node.image,
    imageHeight: IMAGE_HEIGHT,
    slug: `/mi-networks/${obj.node.url}`,
    category: null,
    type: TYPE
  }))

  return (
    <LayoutListView path={location.pathname} configID={configID}>
      <List data={data} itemType="subMenu" className="items-container" />
    </LayoutListView>
  )
}

export default MINetworks

MINetworks.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
}
